import '@/utils/load-image/index.js'
import AppException from './AppException'
class SharedImageThumbnailer {
  constructor () {
    this.isCompressing = false
    this.compressObservers = []

    this.defaultOpt = {
      orientation: true,
      maxWidth: 1920,
      maxHeight: 1080
    }
  }

  validateAlphaContained (file, cb) {
    var reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onloadend = () => {
      let buffer = reader.result

      var view = new DataView(buffer)

      // is a PNG?
      if (view.getUint32(0) === 0x89504E47 && view.getUint32(4) === 0x0D0A1A0A) {
      // We know format field exists in the IHDR chunk. The chunk exists at
      // offset 8 +8 bytes (size, name) +8 (depth) & +9 (type)
        var depth = view.getUint8(8 + 8 + 8)
        var type = view.getUint8(8 + 8 + 9)

        var info = {
          depth: depth,
          type: ['G', '', 'RGB', 'Indexed', 'GA', '', 'RGBA'][type],
          buffer: view.buffer,
          hasAlpha: type === 4 || type === 6 // grayscale + alpha or RGB + alpha
        }

        cb(info.hasAlpha)
      }
    }
  }

  requestCompress (file, cb, opt) {
    this.compressObservers.push({ cb, file, opt })
    if (!this.isCompressing) {
      this.startCompress4()
    }
  }

  cancelCompressRequest (cb) {
    let idx = this.compressObservers.findIndex(o => o.cb === cb)
    if (idx === 0) console.warn('刪除idx=0...可能造成異常')
    if (idx >= 0) this.compressObservers.splice(idx, 1)
  }

  async startCompress4 () {
    this.isCompressing = true
    for (;;) {
      try {
        let target = this.compressObservers[0]

        var opt = Object.assign({}, this.defaultOpt)
        opt = Object.assign(opt, target.opt)

        window.loadImage(
          target.file,
          img => {
            if (img.type === 'error') {
              throw new AppException('compress failed')
            } else {
              var format = 'image/jpeg'
              if (opt.format) { // 1. 強至指定類型
                format = opt.format
                return img.toBlob(
                  (blob) => {
                    target.cb(blob)
                  },
                  format
                )
              }

              // svg不處理
              if (target.file.type === 'image/svg+xml') return target.cb(target.file)
              // gif不處理
              if (target.file.type === 'image/gif') return target.cb(target.file)

              // png 判斷是否有alpha，有的話保留png類型，否則轉換至jpeg
              if (target.file.type === 'image/png') {
                this.validateAlphaContained(target.file, (hasAlpha) => {
                  format = hasAlpha ? 'image/png' : 'image/jpeg'
                  img.toBlob(
                    (blob) => {
                      target.cb(blob)
                    },
                    format
                  )
                })
              } else {
                img.toBlob(
                  (blob) => {
                    target.cb(blob)
                  },
                  format
                )
              }
            }
          },
          opt
        )
      } catch (err) {
        console.error(err)
      }
      this.compressObservers.splice(0, 1)

      if (this.compressObservers.length === 0) break
    }
    this.isCompressing = false
  }
}

const ImageThumbnailer = {
  shared: new SharedImageThumbnailer()
}
export default ImageThumbnailer
